<!--
@component
KnockoutsPage

See markup below.
-->

<script lang="ts">
  import Bracket from '$lib/components/Bracket/index.svelte';
  import ViewSwitch from '$lib/components/common/ViewSwitch/index.svelte';
  import { appState } from '$lib/stores/index.svelte';

  type Props = {
    /** Opta `matches` payload (typed loosely to mirror `appState.optaData`). */
    data: Record<string, any>;
  };

  let { data }: Props = $props();
</script>

<!-- {#if !appState.showKnockouts}
  <ViewSwitch
    to="groups"
    label="Switch to groups"
    blockClass="text-center fmt-6"
  />
{/if} -->
<h1 class="visually-hidden">Knockouts Bracket</h1>
<Bracket {data} />
